
import { WorldCity } from '../types';

// Expansión de Japón - añadiendo 50 ciudades más
export const japanAdditionalCities: WorldCity[] = [
  { name: 'Kurashiki', slug: 'kurashiki', population: 475513 },
  { name: 'Fukushima', slug: 'fukushima', population: 283389 },
  { name: 'Nara', slug: 'nara', population: 358338 },
  { name: 'Takatsuki', slug: 'takatsuki', population: 351829 },
  { name: 'Kashiwa', slug: 'kashiwa', population: 433436 },
  { name: 'Ichikawa', slug: 'ichikawa', population: 498624 },
  { name: 'Toyama', slug: 'toyama', population: 415844 },
  { name: 'Toyota', slug: 'toyota', population: 422542 },
  { name: 'Takamatsu', slug: 'takamatsu', population: 414134 },
  { name: 'Machida', slug: 'machida', population: 428851 },
  { name: 'Gifu', slug: 'gifu', population: 401534 },
  { name: 'Fujisawa', slug: 'fujisawa', population: 436712 },
  { name: 'Kasugai', slug: 'kasugai', population: 306764 },
  { name: 'Hirakata', slug: 'hirakata', population: 398311 },
  { name: 'Hachioji', slug: 'hachioji', population: 577344 },
  { name: 'Matsudo', slug: 'matsudo', population: 498273 },
  { name: 'Kawagoe', slug: 'kawagoe', population: 353214 },
  { name: 'Iwaki', slug: 'iwaki', population: 337390 },
  { name: 'Naha', slug: 'naha', population: 317405 },
  { name: 'Asahikawa', slug: 'asahikawa', population: 327611 },
  { name: 'Komatsu', slug: 'komatsu', population: 108509 },
  { name: 'Yamagata', slug: 'yamagata', population: 248595 },
  { name: 'Sasebo', slug: 'sasebo', population: 254862 },
  { name: 'Koriyama', slug: 'koriyama', population: 321699 },
  { name: 'Mito', slug: 'mito', population: 268750 },
  { name: 'Akita', slug: 'akita', population: 305625 },
  { name: 'Fukui', slug: 'fukui', population: 264706 },
  { name: 'Isesaki', slug: 'isesaki', population: 214485 },
  { name: 'Numazu', slug: 'numazu', population: 194748 },
  { name: 'Ota', slug: 'ota-gunma', population: 224123 },
  { name: 'Fuji', slug: 'fuji', population: 245015 },
  { name: 'Suzuka', slug: 'suzuka', population: 197977 },
  { name: 'Tsu', slug: 'tsu', population: 279886 },
  { name: 'Hitachi', slug: 'hitachi', population: 180271 },
  { name: 'Kashiwazaki', slug: 'kashiwazaki', population: 84692 },
  { name: 'Yamaguchi', slug: 'yamaguchi', population: 194587 },
  { name: 'Tokushima', slug: 'tokushima', population: 253614 },
  { name: 'Matsue', slug: 'matsue', population: 202008 },
  { name: 'Kofu', slug: 'kofu', population: 188193 },
  { name: 'Otsu', slug: 'otsu', population: 343991 },
  { name: 'Maebashi', slug: 'maebashi', population: 334526 },
  { name: 'Kochi', slug: 'kochi', population: 322579 },
  { name: 'Miyazaki', slug: 'miyazaki', population: 400583 },
  { name: 'Aomori', slug: 'aomori', population: 278964 },
  { name: 'Morioka', slug: 'morioka', population: 290700 },
  { name: 'Sendai', slug: 'sendai', population: 1096704 },
  { name: 'Akashi', slug: 'akashi', population: 304152 },
  { name: 'Kakogawa', slug: 'kakogawa', population: 266569 },
  { name: 'Tottori', slug: 'tottori', population: 187167 },
  { name: 'Yonago', slug: 'yonago', population: 146139 }
];

// Exportar también el país completo expandido
export const japanExpansion = {
  code: 'JP',
  name: 'Japan',
  slug: 'japan',
  population: 125800000,
  topCities: [
    { name: 'Tokyo', slug: 'tokyo', population: 37400068 },
    { name: 'Yokohama', slug: 'yokohama', population: 3726167 },
    { name: 'Osaka', slug: 'osaka', population: 2725006 },
    { name: 'Nagoya', slug: 'nagoya', population: 2296014 },
    { name: 'Sapporo', slug: 'sapporo', population: 1952356 },
    { name: 'Fukuoka', slug: 'fukuoka', population: 1538681 },
    { name: 'Kobe', slug: 'kobe', population: 1537272 },
    { name: 'Kawasaki', slug: 'kawasaki', population: 1475213 },
    { name: 'Kyoto', slug: 'kyoto', population: 1474570 },
    { name: 'Saitama', slug: 'saitama', population: 1324854 },
    ...japanAdditionalCities
  ]
};
